import { Route } from 'react-router-dom';
import createLazyPage from '@/components/LazyPage';

const LiveServicesTab = createLazyPage({
    loadPage: () => import('../ServicesTab/LiveServicesTab'),
});
const LiveInstancePage = createLazyPage({
    loadPage: () => import('../ServicesTab/LiveServicesTab/LiveInstancePage'),
});
const LiveInstanceIndexRedirect = createLazyPage({
    loadPage: () =>
        import('../ServicesTab/LiveServicesTab/LiveInstancePage/LiveInstanceIndexRedirect'),
});
const LiveBillingTab = createLazyPage({
    loadPage: () => import('../ServicesTab/LiveServicesTab/LiveInstancePage/LiveBillingTab'),
});
const LiveRequirementsTab = createLazyPage({
    loadPage: () => import('../ServicesTab/LiveServicesTab/LiveInstancePage/LiveRequirementsTab'),
});
const LivePlaybooksTab = createLazyPage({
    loadPage: () => import('../ServicesTab/LiveServicesTab/LiveInstancePage/LivePlaybooksTab'),
});
const LiveAttachmentsTab = createLazyPage({
    loadPage: () => import('../ServicesTab/LiveServicesTab/LiveInstancePage/LiveAttachmentsTab'),
});

const createLiveOrganizationServicesRoute = () => (
    <Route path="services" element={<LiveServicesTab />}>
        <Route path=":instanceId" element={<LiveInstancePage />}>
            <Route index element={<LiveInstanceIndexRedirect />} />
            <Route path="billing" element={<LiveBillingTab />} />
            <Route path="requirements" element={<LiveRequirementsTab />} />
            <Route path="playbooks" element={<LivePlaybooksTab />} />
            <Route path="attachments" element={<LiveAttachmentsTab />} />
        </Route>
    </Route>
);

export default createLiveOrganizationServicesRoute;
